import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {

  constructor(private httpService: HttpService) {

  }

  getDetailsList(paramData){
      var request = {
          URL: "upsidetails",
          DATA:paramData
      }
      return this.httpService.post(request);
  }

  deleteDetails(detailsId){
      var request = {
          URL: "details/delete/"+detailsId,
        
      }
      return this.httpService.get(request);     
  }

  editDetails(detailsId){
      
      var request = {
          URL: 'details/edit/' + detailsId
      }
      return this.httpService.get(request);
  }

  getDetailsHistory(detailsId){
      var request = {
          URL: 'details/history/' + detailsId
      }
      return this.httpService.get(request);
  }
  getEmailsLog(paramData) {
    var request = {
      URL: "emailsUpsiLog",
      DATA: paramData
    }
    return this.httpService.post(request);
  }
  // getTokenStatus(token){

  //     var request = {
  //         URL: "oauth/validateRequest",
  //         DATA:{token}
  //     }
  //     return this.httpService.postForToken(request);

  // }

  // checkRoutesAuth(UrlState){
  //     UrlState = UrlState === 'users' ? 'userMaster/userManagement' : UrlState;
  //     var request = {
  //         URL: "user/routesAuth",
  //         DATA : {'url':UrlState}
       
  //     }
  //     return this.httpService.getGovEvaCallPost(request);
  // }

  updateActivity(){
      var request = {
          URL: "updateAactivityTime",
         
      }
      return this.httpService.getGovEvaCall(request);
  }

}
